module.exports = __webpack_public_path__ + "img/4.27891720.jpg";